const _excluded = ["onChange", "value"],
  _excluded2 = ["onChange"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import cn from 'classnames';
import { useOverlayContext } from 'seagull';
import { range } from 'lodash-es';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { Button, Card, InfoIcon, MenuItem, Page, Select, Typography, Checkbox, WithInfoIcon } from 'seagull';
import { useStore } from "../../store/store-context";
import LegalTermsDropdown from "../../components/LegalTermsDropdown/LegalTermsDropdown";
import { businessSettingsDefaults, daysOfWeek, netTermsOptions } from "../../constants";
import { useStoreActions, useStoreStatic } from "../../contexts";
import { sendErrReport } from "../../infra/utils";
import { StartBillingOnEnum } from "../../types/api.model";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { selectors } from "../../store/state-selectors";
import { RequestAccountantAccess, requestAccountantAccessModel } from "../../models/request-accountant-access";
import { accountantAccessInfoTooltip } from "../../business-logic/accountantAccessLogic";
import IntroductoryMessageEditor from "./IntroductoryMessageEditor/IntroductoryMessageEditor";
import { BillingDayOfMonthModel, BillingDayOfMonthType, approvalMethodNoticePeriodModel } from "../../models";
import { NavigationGuardModal } from "../../components/NavigationGuardModal";
import { getAllAutoApprovalDays } from "../../business-logic/autoApprovalLogic";
import IntroVideoField from "../../components/AgreementStudio/IntroVideo/IntroVideoField";
import styles from "./ProposalDefaults.module.scss";
import { makeExpirationDate } from "../../models/expiration-date";
import pluralize from "../../utils/pluralize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const testPrefix = 'settings-business-settings';
const newTitle = 'Default settings';
const updateLoader = 'updateBusinessSettings';
var FormFieldType = /*#__PURE__*/function (FormFieldType) {
  FormFieldType["Input"] = "input";
  FormFieldType["Heading"] = "heading";
  FormFieldType["Separator"] = "separator";
  FormFieldType["LegalTermsUpload"] = "legalTermsUpload";
  return FormFieldType;
}(FormFieldType || {});
const formId = 'business-settings-form';
export default function ProposalDefaults() {
  var _worksAt$settings, _worksAt$settings2, _worksAt$settings3, _worksAt$settings4, _worksAt$settings5, _worksAt$settings6, _worksAt$settings7, _worksAt$settings8, _worksAt$settings9, _worksAt$settings10, _worksAt$settings11, _worksAt$settings12, _worksAt$settings13, _worksAt$settings14, _worksAt$settings15, _worksAt$settings16, _worksAt$settings17, _worksAt$settings18, _worksAt$settings19, _worksAt$settings20;
  const worksAt = useStore(selectors.user.business);
  const authToken = useStore(state => state.authToken);
  const {
    api,
    setWorksAt,
    fetchUserInfo,
    fetchLegalTerms
  } = useStoreActions();
  const {
    getState
  } = useStoreStatic();
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const allLegalTerms = useStore(state => state.legalTerms.data);
  const [isLegalTermsFieldDirty, setIsLegalTermsFieldDirty] = useState(false);
  const billingDayOfMonthOptions = range(1, 29).map(day => BillingDayOfMonthModel.make(day)).concat([BillingDayOfMonthModel.make()]);
  const autoApprovalOptions = useMemo(() => {
    return [approvalMethodNoticePeriodModel.makeManualApprovalMethodNoticePeriod()].concat(getAllAutoApprovalDays().map(approvalMethodNoticePeriodModel.makeAutoApprovalMethodNoticePeriod));
  }, []);
  const startBillingOnMode = (worksAt === null || worksAt === void 0 || (_worksAt$settings = worksAt.settings) === null || _worksAt$settings === void 0 ? void 0 : _worksAt$settings.startBillingOn) || businessSettingsDefaults.startBillingOn || StartBillingOnEnum.SkipBillingOnAcceptance;
  const selectedBillingDayOfMonth = (worksAt === null || worksAt === void 0 || (_worksAt$settings2 = worksAt.settings) === null || _worksAt$settings2 === void 0 ? void 0 : _worksAt$settings2.billingDayOfMonth) || businessSettingsDefaults.billingDayOfMonth;
  if (selectedBillingDayOfMonth.type === BillingDayOfMonthType.LastDayOfMonth) delete selectedBillingDayOfMonth['day'];
  const defaultValues = {
    legalTermsDocumentId: (worksAt === null || worksAt === void 0 || (_worksAt$settings3 = worksAt.settings) === null || _worksAt$settings3 === void 0 ? void 0 : _worksAt$settings3.legalTermsDocumentId) || businessSettingsDefaults.legalTermsDocumentId,
    disablePlaidLink: (worksAt === null || worksAt === void 0 || (_worksAt$settings4 = worksAt.settings) === null || _worksAt$settings4 === void 0 ? void 0 : _worksAt$settings4.disablePlaidLink) || businessSettingsDefaults.disablePlaidLink,
    netTerms: (worksAt === null || worksAt === void 0 || (_worksAt$settings5 = worksAt.settings) === null || _worksAt$settings5 === void 0 ? void 0 : _worksAt$settings5.netTerms) || businessSettingsDefaults.netTerms,
    billingDayOfMonth: selectedBillingDayOfMonth,
    billingDayOfWeek: (worksAt === null || worksAt === void 0 || (_worksAt$settings6 = worksAt.settings) === null || _worksAt$settings6 === void 0 ? void 0 : _worksAt$settings6.billingDayOfWeek) || businessSettingsDefaults.billingDayOfWeek,
    feeControls: {
      coverCreditCardFees: (worksAt === null || worksAt === void 0 || (_worksAt$settings7 = worksAt.settings) === null || _worksAt$settings7 === void 0 ? void 0 : _worksAt$settings7.feeControls.coverCreditCardFees) || businessSettingsDefaults.feeControls.coverCreditCardFees,
      coverDirectDebitFees: (worksAt === null || worksAt === void 0 || (_worksAt$settings8 = worksAt.settings) === null || _worksAt$settings8 === void 0 ? void 0 : _worksAt$settings8.feeControls.coverDirectDebitFees) || businessSettingsDefaults.feeControls.coverDirectDebitFees
    },
    amendmentsApprovalMethod: (worksAt === null || worksAt === void 0 || (_worksAt$settings9 = worksAt.settings) === null || _worksAt$settings9 === void 0 ? void 0 : _worksAt$settings9.amendmentsApprovalMethod) || businessSettingsDefaults.amendmentsApprovalMethod,
    invoicesApprovalMethod: (worksAt === null || worksAt === void 0 || (_worksAt$settings10 = worksAt.settings) === null || _worksAt$settings10 === void 0 ? void 0 : _worksAt$settings10.invoicesApprovalMethod) || businessSettingsDefaults.invoicesApprovalMethod,
    billUpfront: (worksAt === null || worksAt === void 0 || (_worksAt$settings11 = worksAt.settings) === null || _worksAt$settings11 === void 0 ? void 0 : _worksAt$settings11.billUpfront) || businessSettingsDefaults.billUpfront,
    automaticServicesPausedByDefault: (worksAt === null || worksAt === void 0 || (_worksAt$settings12 = worksAt.settings) === null || _worksAt$settings12 === void 0 ? void 0 : _worksAt$settings12.automaticServicesPausedByDefault) || businessSettingsDefaults.automaticServicesPausedByDefault,
    prorateFirstInvoice: (worksAt === null || worksAt === void 0 || (_worksAt$settings13 = worksAt.settings) === null || _worksAt$settings13 === void 0 ? void 0 : _worksAt$settings13.prorateFirstInvoice) || businessSettingsDefaults.prorateFirstInvoice,
    requestAccountantAccess: (worksAt === null || worksAt === void 0 || (_worksAt$settings14 = worksAt.settings) === null || _worksAt$settings14 === void 0 ? void 0 : _worksAt$settings14.requestAccountantAccess) || businessSettingsDefaults.requestAccountantAccess,
    introductoryMessages: {
      proposal: (worksAt === null || worksAt === void 0 || (_worksAt$settings15 = worksAt.settings) === null || _worksAt$settings15 === void 0 ? void 0 : _worksAt$settings15.introductoryMessages.proposal) || businessSettingsDefaults.introductoryMessages.proposal,
      invitation: (worksAt === null || worksAt === void 0 || (_worksAt$settings16 = worksAt.settings) === null || _worksAt$settings16 === void 0 ? void 0 : _worksAt$settings16.introductoryMessages.invitation) || businessSettingsDefaults.introductoryMessages.invitation
    },
    startBillingOn: (worksAt === null || worksAt === void 0 || (_worksAt$settings17 = worksAt.settings) === null || _worksAt$settings17 === void 0 ? void 0 : _worksAt$settings17.startBillingOn) || businessSettingsDefaults.startBillingOn,
    introVideo: (worksAt === null || worksAt === void 0 || (_worksAt$settings18 = worksAt.settings) === null || _worksAt$settings18 === void 0 ? void 0 : _worksAt$settings18.introVideo) || businessSettingsDefaults.introVideo,
    selectedTemplate: 'introductoryMessages.proposal',
    startPaused: startBillingOnMode === StartBillingOnEnum.StartPaused,
    billOnAcceptance: startBillingOnMode === StartBillingOnEnum.Earliest,
    expirationDate: (worksAt === null || worksAt === void 0 || (_worksAt$settings19 = worksAt.settings) === null || _worksAt$settings19 === void 0 ? void 0 : _worksAt$settings19.expirationDate) || businessSettingsDefaults.expirationDate,
    invoicePrefix: (worksAt === null || worksAt === void 0 || (_worksAt$settings20 = worksAt.settings) === null || _worksAt$settings20 === void 0 ? void 0 : _worksAt$settings20.invoicePrefix) || businessSettingsDefaults.invoicePrefix
  };
  delete defaultValues['defaultLegalTermsDocumentId'];
  delete defaultValues['defaultBillingDayOfMonth'];
  const {
    control,
    handleSubmit,
    formState,
    getValues,
    reset,
    setValue
  } = useForm({
    defaultValues,
    mode: 'onSubmit'
  });
  const [lastDayOptionDisabled, setLastDayOptionDisabled] = useState(getValues('billUpfront'));
  const billUpfront = useWatch({
    name: 'billUpfront',
    control
  });
  const startPaused = useWatch({
    name: 'startPaused',
    control
  });
  const billOnAcceptance = useWatch({
    name: 'billOnAcceptance',
    control
  });
  const prorateFirstInvoice = useWatch({
    name: 'prorateFirstInvoice',
    control
  });
  const startBillingOn = useWatch({
    name: 'startBillingOn',
    control
  });
  const introVideo = useWatch({
    name: 'introVideo',
    control
  });
  const billingDayOfMonth = useWatch({
    name: 'billingDayOfMonth.type',
    control
  });
  const legalTermsDocumentId = useWatch({
    name: 'legalTermsDocumentId',
    control
  });
  const [isProrationDisabled, setIsProrationDisabled] = useState(false);
  const [isStartPausedDisabled, setIsStartPausedDisabled] = useState(false);
  const [isBillOnAcceptanceDisabled, setIsBillOnAcceptanceDisabled] = useState(false);
  const billUpfrontErrorShown = billUpfront && billingDayOfMonth === BillingDayOfMonthType.LastDayOfMonth;
  useSetDocumentTitle(newTitle);
  useEffect(() => {
    (async () => {
      if (!authToken || !worksAt) return;
      const loaderName = 'legalTerms';
      startLoader(loaderName);
      const legalTerms = await fetchLegalTerms();
      if (legalTerms) {
        var _selectors$user$busin;
        const legalTermsFromSettings = (_selectors$user$busin = selectors.user.businessSettings(getState())) === null || _selectors$user$busin === void 0 ? void 0 : _selectors$user$busin.legalTermsDocumentId;
        const newSelectedLegalTerms = legalTerms.find(term => term.id === legalTermsFromSettings);
        if (newSelectedLegalTerms) {
          setValue('legalTermsDocumentId', newSelectedLegalTerms.id);
        }
      }
      stopLoader(loaderName);
    })();
  }, [authToken, worksAt]);
  useEffect(() => {
    if (!billUpfront && startBillingOn === StartBillingOnEnum.Earliest) {
      setValue('startBillingOn', StartBillingOnEnum.SkipBillingOnAcceptance);
    }
  }, [billUpfront, startBillingOn]);
  useEffect(() => {
    const isProrationInvalid = startPaused || !billOnAcceptance && billUpfront;
    setIsProrationDisabled(isProrationInvalid);
    setValue('prorateFirstInvoice', isProrationInvalid ? false : prorateFirstInvoice);
  }, [startPaused, billOnAcceptance, billUpfront, setValue, prorateFirstInvoice]);
  useEffect(() => {
    const isStartPausedInvalid = billUpfront && billOnAcceptance;
    setIsStartPausedDisabled(isStartPausedInvalid);
    setValue('startPaused', isStartPausedInvalid ? false : startPaused);
  }, [billOnAcceptance, billUpfront, setValue, startPaused]);
  useEffect(() => {
    const isBillOnAcceptanceInvalid = startPaused || !billUpfront;
    setIsBillOnAcceptanceDisabled(isBillOnAcceptanceInvalid);
    setValue('billOnAcceptance', isBillOnAcceptanceInvalid ? false : billOnAcceptance);
  }, [startPaused, billUpfront, setValue, billOnAcceptance]);
  const selectedLegalTerms = useMemo(() => {
    return allLegalTerms ? allLegalTerms.find(lt => lt.id === legalTermsDocumentId) : undefined;
  }, [allLegalTerms, legalTermsDocumentId]);
  const fields = [{
    type: FormFieldType.Heading,
    label: 'General settings'
  }, {
    type: FormFieldType.LegalTermsUpload,
    label: 'Terms and conditions'
  }, {
    type: FormFieldType.Input,
    name: 'amendmentsApprovalMethod',
    label: 'Automatically approve amendments after a defined period',
    tooltip: 'Amendments will take effect automatically if the client doesn’t disable within the notice period set. Invoices issued during the notice period will require client approval.',
    options: autoApprovalOptions.map(option => ({
      value: option,
      label: approvalMethodNoticePeriodModel.isAutoApproval(option) ? "Enabled with ".concat(pluralize('day', option.auto.noticePeriodDays, true), " notice") : 'Disabled'
    }))
  }, {
    type: FormFieldType.Input,
    name: 'invoicesApprovalMethod',
    label: 'Automatically approve out-of-scope charges after a defined period',
    tooltip: 'Invoices that require client approval will be automatically approved within the notice period set, unless approved earlier or if auto-approval is disabled.',
    options: autoApprovalOptions.map(option => ({
      value: option,
      label: approvalMethodNoticePeriodModel.isAutoApproval(option) ? "Enabled with ".concat(pluralize('day', option.auto.noticePeriodDays, true), " notice") : 'Disabled'
    }))
  }, {
    type: FormFieldType.Input,
    name: 'netTerms',
    label: 'Number of days until payment is due',
    options: netTermsOptions.map(numOfDays => ({
      label: numOfDays === 0 ? 'On acceptance' : pluralize('day', numOfDays, true),
      value: numOfDays
    }))
  }, {
    type: FormFieldType.Input,
    name: 'feeControls.coverCreditCardFees',
    label: 'Credit card processing fee is paid by',
    options: [{
      label: 'The client',
      value: false
    }, {
      label: "".concat((worksAt === null || worksAt === void 0 ? void 0 : worksAt.name) || 'The vendor'),
      value: true
    }]
  }, {
    type: FormFieldType.Input,
    name: 'expirationDate',
    label: 'Proposal expiration in days',
    options: [{
      label: "Proposals don't expire",
      value: makeExpirationDate()
    }, ...range(1, 91).map(day => ({
      label: day + '',
      value: makeExpirationDate(day)
    }))]
  }, {
    type: FormFieldType.Input,
    name: 'requestAccountantAccess',
    label: "Request Accountant Access to a client's Anchor account",
    tooltip: accountantAccessInfoTooltip,
    isCheckbox: true,
    mapValue: value => requestAccountantAccessModel.wasRequested(value),
    mapOnChange: event => event.target.checked ? RequestAccountantAccess.Mandatory : RequestAccountantAccess.None
  }, {
    type: FormFieldType.Separator
  }, {
    type: FormFieldType.Heading,
    label: 'Automatic services settings'
  }, {
    type: FormFieldType.Input,
    name: 'billUpfront',
    label: 'Billing is done',
    options: [{
      value: true,
      label: 'Upfront'
    }, {
      value: false,
      label: 'At the end of each billing cycle'
    }]
  }, {
    type: FormFieldType.Input,
    name: 'billingDayOfMonth',
    label: 'Billing day for monthly services',
    tooltip: 'This will set the issue day of month only for monthly services that are billed automatically.',
    options: billingDayOfMonthOptions.map(option => ({
      label: option.formatDay('Last day of the month'),
      value: option,
      disabled: option.isLast() && lastDayOptionDisabled
    })),
    error: billUpfrontErrorShown,
    helperText: billUpfrontErrorShown ? 'To continue, please change the monthly billing day' : ''
  }, {
    type: FormFieldType.Input,
    name: 'billingDayOfWeek',
    label: 'Billing day for weekly services',
    tooltip: 'This will set the issue day of week only for weekly services that are billed automatically.',
    options: daysOfWeek.map(value => ({
      value,
      label: value
    }))
  }, {
    type: FormFieldType.Input,
    isCheckbox: true,
    name: 'startPaused',
    disabled: isStartPausedDisabled,
    label: 'Do not start automatic billing',
    tooltip: 'The service will not be billed until you manually resume automatic billing for it.',
    options: [{
      label: 'Disabled',
      value: false
    }, {
      label: "Enabled",
      value: true
    }]
  }, {
    type: FormFieldType.Input,
    isCheckbox: true,
    name: 'billOnAcceptance',
    disabled: isBillOnAcceptanceDisabled,
    label: 'Issue an invoice on proposal acceptance',
    tooltip: 'The service will be charged on the day the proposal is accepted (even if it’s not the set billing date) and continue issuing from the next scheduled billing date and going forward.',
    options: [{
      label: 'Disabled',
      value: false
    }, {
      label: "Enabled",
      value: true
    }]
  }, {
    type: FormFieldType.Input,
    isCheckbox: true,
    name: 'prorateFirstInvoice',
    label: 'First month proration',
    disabled: isProrationDisabled,
    tooltip: 'When checked, the price of automatic services in the first invoice will be calculated in proportion to the number of days the agreement was in effect during the billing cycle',
    options: [{
      label: 'Disabled',
      value: false
    }, {
      label: "Enabled",
      value: true
    }]
  }, {
    type: FormFieldType.Separator
  }];
  const onSubmit = async values => {
    if (!worksAt) return;
    if (billUpfrontErrorShown) return;
    startLoader(updateLoader);
    const params = _objectSpread(_objectSpread({}, values), {}, {
      coverCreditCardFees: values.feeControls.coverCreditCardFees,
      startBillingOn: values.startPaused ? StartBillingOnEnum.StartPaused : values.billOnAcceptance ? StartBillingOnEnum.Earliest : StartBillingOnEnum.SkipBillingOnAcceptance
    });
    delete params['selectedTemplate'];
    delete params['feeControls'];
    delete params['disablePlaidLink'];
    delete params['startPaused'];
    delete params['billOnAcceptance'];
    try {
      await api.vendor.updateBusinessSettings(worksAt.id, params);
      const settings = await api.vendor.getBusinessSettings(worksAt.id);
      if (settings) {
        setWorksAt(Object.assign({}, worksAt, {
          settings
        }));
      }
      setIsLegalTermsFieldDirty(false);
      reset(undefined, {
        keepValues: true
      });
    } catch (error) {
      showErrorToast('Failed to save changes.', 'save-error-toast');
      sendErrReport(error);
    }
    stopLoader(updateLoader);
  };
  return /*#__PURE__*/_jsxs(Page, {
    header: /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      children: "Proposals default configuration"
    }),
    subheader: /*#__PURE__*/_jsx(Typography, {
      children: "Set the default values of new proposals you create"
    }),
    "data-testid": testPrefix + '-screen',
    minWidth: "978px",
    actions: /*#__PURE__*/_jsx(Button, {
      loading: formState.isSubmitting,
      "data-testid": testPrefix + '-btn-save-changes',
      form: formId,
      type: "submit",
      children: "Save Changes"
    }),
    skin: "secondary",
    children: [/*#__PURE__*/_jsxs(Card, {
      autoHeight: true,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.titles
      }), /*#__PURE__*/_jsxs("form", {
        id: formId,
        className: styles.form,
        onSubmit: handleSubmit(onSubmit),
        children: [fields.map((fieldConfig, idx) => {
          if (fieldConfig.type === FormFieldType.Input) {
            const {
              name,
              label,
              tooltip,
              options,
              error,
              helperText,
              isCheckbox,
              disabled,
              mapValue,
              mapOnChange
            } = fieldConfig;
            if (isCheckbox) {
              return /*#__PURE__*/_jsx("div", {
                className: cn(styles.fieldWithTooltip, styles.checkboxField),
                children: /*#__PURE__*/_jsx(Controller, {
                  control: control,
                  name: name,
                  render: _ref => {
                    let {
                        field: {
                          onChange: _onChange,
                          value
                        }
                      } = _ref,
                      field = _objectWithoutProperties(_ref.field, _excluded);
                    return tooltip ? /*#__PURE__*/_jsx(WithInfoIcon, {
                      info: tooltip,
                      children: /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
                        "data-testid": "".concat(testPrefix, "-").concat(name),
                        checked: mapValue ? mapValue(value) : value,
                        disabled: disabled,
                        onChange: event => _onChange(mapOnChange ? mapOnChange(event) : event)
                      }, field), {}, {
                        children: /*#__PURE__*/_jsx(Typography, {
                          skin: disabled ? 'disabled' : 'standard',
                          children: label
                        })
                      }), name)
                    }) : /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
                      "data-testid": "".concat(testPrefix, "-").concat(name),
                      checked: value,
                      disabled: disabled,
                      onChange: _onChange
                    }, field), {}, {
                      children: /*#__PURE__*/_jsx(Typography, {
                        skin: disabled ? 'disabled' : 'standard',
                        children: label
                      })
                    }), name);
                  }
                })
              }, name);
            } else {
              return /*#__PURE__*/_jsxs(Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.fieldWithTooltip,
                  children: [/*#__PURE__*/_jsx(Typography, {
                    children: label
                  }), tooltip && /*#__PURE__*/_jsx(InfoIcon, {
                    info: tooltip
                  })]
                }), /*#__PURE__*/_jsx(Controller, {
                  control: control,
                  name: name,
                  render: props => {
                    const _connectControllerToT = connectControllerToTextField(props),
                      {
                        onChange: _onChange2
                      } = _connectControllerToT,
                      rest = _objectWithoutProperties(_connectControllerToT, _excluded2);
                    const value = getValues(name);
                    const isObject = typeof value === 'object';
                    const primitiveValue = isObject ? JSON.stringify(value) : value;
                    return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, rest), {}, {
                      value: primitiveValue,
                      onChange: e => {
                        if (isObject) {
                          e.target.value = JSON.parse(e.target.value);
                        }
                        _onChange2(e);
                      },
                      menuMaxHeight: 300,
                      SelectProps: {
                        onOpen: () => {
                          setLastDayOptionDisabled(getValues('billUpfront'));
                        }
                      },
                      error: error,
                      helperText: helperText,
                      "data-testid": "".concat(testPrefix, "-").concat(name),
                      children: options === null || options === void 0 ? void 0 : options.map((_ref2, i) => {
                        let {
                          value,
                          label,
                          disabled
                        } = _ref2;
                        const primitiveValue = typeof value === 'object' ? JSON.stringify(value) : value;
                        return /*#__PURE__*/_jsx(MenuItem, {
                          value: primitiveValue,
                          "data-testid": "".concat(testPrefix, "-").concat(name, "-option-").concat(i),
                          disabled: disabled,
                          children: label
                        }, primitiveValue);
                      })
                    }));
                  }
                })]
              }, name);
            }
          } else if (fieldConfig.type === FormFieldType.Heading) {
            return /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                children: fieldConfig.label
              }), /*#__PURE__*/_jsx("div", {})]
            }, idx);
          } else if (fieldConfig.type === FormFieldType.Separator) {
            return /*#__PURE__*/_jsx(Fragment, {
              children: /*#__PURE__*/_jsx("div", {
                className: styles.separator
              })
            }, idx);
          } else if (fieldConfig.type === FormFieldType.LegalTermsUpload) {
            return /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(Typography, {
                children: fieldConfig.label
              }), /*#__PURE__*/_jsx(LegalTermsDropdown, {
                showViewTosButton: true,
                selectedLegalTerms: selectedLegalTerms,
                legalTerms: allLegalTerms || [],
                onChange: legalTerms => {
                  setIsLegalTermsFieldDirty(true);
                  setValue('legalTermsDocumentId', legalTerms);
                },
                onUpload: fetchLegalTerms,
                onRemove: async legalTermsId => {
                  try {
                    startLoader();
                    await api.business.removeLegalTerms(legalTermsId);
                    // Will also refresh legalTerms because of a useEffect above.
                    await fetchUserInfo();
                  } catch (err) {
                    showErrorToast('Failed to remove terms.', 'rm-term-fail');
                  } finally {
                    stopLoader();
                  }
                }
              })]
            }, idx);
          }
        }), /*#__PURE__*/_jsx(IntroductoryMessageEditor, {
          selectedTemplateFormFieldName: "selectedTemplate",
          templates: [{
            name: 'introductoryMessages.proposal',
            dropdownLabel: 'New client onboarding template'
          }, {
            name: 'introductoryMessages.invitation',
            dropdownLabel: 'Existing client onboarding template'
          }],
          control: control,
          formState: formState
        }), /*#__PURE__*/_jsx(IntroVideoField, {
          introVideo: introVideo,
          onChange: introVideo => setValue('introVideo', introVideo, {
            shouldDirty: true
          }),
          className: styles.video
        })]
      })]
    }), /*#__PURE__*/_jsx(NavigationGuardModal, {
      when: formState.isDirty || isLegalTermsFieldDirty,
      primaryButtonTestId: "business-settings-confirm-navigation",
      secondaryButtonTestId: "business-settings-keep-editing"
    })]
  });
}